import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    context: '',
  },
  mutations: {
    setContext(state, payload) {
      Vue.set(state, 'context', payload);
    },
  },
  actions: {
    updateContext({ commit }, data) {
      commit('setContext', data.context);
    },
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js